<app-grid
    [selectBy]="itemIdentifier"
    [data]="filteredData"
    [cols]="columns"
    [buttons]="gridButtons"
    [selectable]="{
        enabled: true,
        checkboxOnly: true
    }"
    [selection]="selectedIds"
    [pageSize]="100"
    [sortable]="true"
    [filterable]="false"
    [reorderable]="false"
    [allowGridSave]="false"
    [showColumnSelector]="false"
    [applyLocalPagination]="true"
    (selectedKeysChange)="onSelectedIdsChange($event)">
    @if (showTariffTypeFilters()) {
        <app-toggle-group
            toolbarCenter
            shape="square"
            [items]="quickFilters"
            [shouldPersistState]="false"
            (itemToggled)="onQuickFilterClick($event)" />
    }
    <ng-container toolbarEnd>
        <app-codelist-input
            class="min-w-48"
            id="serviceId"
            codelist="Service"
            [placeholder]="'Service' | translate"
            [isEditMode]="true"
            [(value)]="filter.serviceId"
            (valueChange)="getFilteredData()" />
    </ng-container>
</app-grid>
